import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {PlanningService} from '@app/shared/services/planning.service';
import {Injectable} from '@angular/core';
import {CookieService} from '@app/shared/services/cookie.service';
import {Observable} from 'rxjs/Observable';

export const recipeAddedId = 11651;

@Injectable()
export class IntroService {
  constructor(
    private planningService: PlanningService,
    private cookieService: CookieService
  ) {}

  public introStage = new BehaviorSubject<number>(0);
  private showPopupStartIntro = new BehaviorSubject<boolean>(false);
  introAddedId_PlanStage: number|null = null;

  getPopupStartIntro(): Observable<boolean> {
    return this.showPopupStartIntro.asObservable();
  }

  public setPopupStartIntro(stage) {
    this.showPopupStartIntro.next(stage);
  }

  public getIntroStage() {
    return this.introStage.asObservable();
  }

  public setIntroStage(stage) {
    this.introStage.next(stage);
  }

  public setCookieStudyLong() {
    const time = 3600 * 1000 * 24 * 365 * 10;
    this.cookieService.writeStudyPopCookie(true, time);
  }

  public setIntroIdPlanStage(number) {
    this.introAddedId_PlanStage = number;
  }

  removeIntroAddedRecipe() {
    this.setIntroStage(0);
    if (this.introAddedId_PlanStage !== null) {
      const number = +this.introAddedId_PlanStage;
      this.planningService.deleteStage(number).then(() => {
        window.location.href = '/main/recipes/list';
      });
    } else {
      window.location.href = '/main/recipes/list';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/intro.service.ts